import * as React from "react";
function TruckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 432.5 197",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1,.cls-2{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:4px}.cls-2{stroke-linecap:round}\n    ")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.5 162h-31V2h246v122M324.5 162H215.41M359.5 124V45.19A19.19 19.19 0 01378.69 26h32.62a19.19 19.19 0 0119.19 19.19v97.62A19.19 19.19 0 01411.31 162H395.5",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.41 162a35.46 35.46 0 11.09-2.49q0 1.26-.09 2.49",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 159.5,
    r: 35.5,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 117.5H2M98 137.5H22M98 157.5H42",
    className: "cls-2"
  }))));
}
const ForwardRef = React.forwardRef(TruckIcon);
export default ForwardRef;